<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Pembayaran Cash</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listData" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationData.total_data">
				<template v-slot:item.trx_payment_cash_datetime="{ item }">
					<div class="pt-2">{{item.trx_payment_cash_datetime | tanggaljam}}</div>
				</template>
				<template v-slot:item.stockist="{ item }">
					<div class="pt-2">{{item.stockist_code}} - {{item.stockist_name}}</div>
				</template>
				<template v-slot:item.trx_payment_cash_value="{ item }">
					<div class="pt-2">{{item.trx_payment_cash_value | toRupiah}}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationData">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationData">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationData.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationData.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	data() {
		return {
			trx_id: '',
			sortBy: 'trx_payment_bank_trx_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Kode Transaksi', align: 'start', value: 'trx_code'},
			{ text: 'Stockist', value: 'stockist', width: '30%', sortable: false },
			{ text: 'Nominal', value: 'trx_payment_cash_value'},
			{ text: 'Waktu Transaksi', value: 'trx_payment_cash_datetime'},
			{ text: 'Keterangan', value: 'trx_payment_cash_note'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Transaksi',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_code'
				}
			}, {
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal Input',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'trx_payment_cash_datetime'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceTransaction', ['listData', 'paginationData', 'listStatus']),
	},
	methods: {
		...mapActions('ecommerceTransaction', ['getTransactionCash', 'exportTransactionCash']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceTransaction', ['clearDataTransaction']),

		getData() {
			this.getTransactionCash(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportTransactionCash(this.queryString({params: this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		this.clearDataTransaction()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Transaction Cash`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>